export const builder = {
    typography: {
        lineHeight: 1.6,
    },
};
//# sourceMappingURL=builder.js.map